var _style, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStars45 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlSpace: "preserve",
  id: "Layer_1",
  x: 0,
  y: 0,
  viewBox: "0 0 512 96"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".st0{fill:#00b67a}.st2{fill:#fff}")), /*#__PURE__*/React.createElement("g", {
  id: "Trustpilot_ratings_4halfstar-RGB"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  id: "Rectangle-path",
  d: "M0 0h96v96H0z",
  className: "st0"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M104 0h96v96h-96zM208 0h96v96h-96zM312 0h96v96h-96z",
  className: "st0"
})), /*#__PURE__*/React.createElement("g", {
  id: "Half"
}, /*#__PURE__*/React.createElement("path", {
  d: "M48 0h48v96H48z",
  style: {
    fill: "#dcdce6"
  },
  transform: "translate(416)"
}), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M416 0h48v96h-48z",
  className: "st0"
}))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  d: "M48 64.7 62.6 61l6.1 18.8zm33.6-24.3H55.9L48 16.2l-7.9 24.2H14.4l20.8 15-7.9 24.2 20.8-15 12.8-9.2z",
  className: "st2"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  d: "m152 64.7 14.6-3.7 6.1 18.8zm33.6-24.3h-25.7L152 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2zM256 64.7l14.6-3.7 6.1 18.8zm33.6-24.3h-25.7L256 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2zM360 64.7l14.6-3.7 6.1 18.8zm33.6-24.3h-25.7L360 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2zM464 64.7l14.6-3.7 6.1 18.8zm33.6-24.3h-25.7L464 16.2l-7.9 24.2h-25.7l20.8 15-7.9 24.2 20.8-15 12.8-9.2z",
  className: "st2"
}))));
export default SvgStars45;